import { render, staticRenderFns } from "./Failed.vue?vue&type=template&id=5ab28a87&scoped=true&lang=pug&"
import script from "./Failed.vue?vue&type=script&lang=ts&"
export * from "./Failed.vue?vue&type=script&lang=ts&"
import style0 from "./Failed.vue?vue&type=style&index=0&id=5ab28a87&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab28a87",
  null
  
)

export default component.exports